var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7142 6H4.28575C3.02346 6 2 7.0234 2 8.28568V31.7143C2 32.9765 3.02346 33.9999 4.28575 33.9999H35.7142C36.9765 33.9999 38 32.9765 38 31.7142V8.28568C38 7.0234 36.9766 6 35.7142 6ZM35.7142 8.28568V24.909L31.2096 20.8136C30.5326 20.1982 29.4914 20.2228 28.8445 20.8702L24.2856 25.4285L15.2966 14.6914C14.6171 13.8799 13.3725 13.8719 12.6829 14.6736L4.28575 24.4325V8.28568H35.7142ZM26 14.2857C26 12.5497 27.4067 11.1428 29.1428 11.1428C30.8788 11.1428 32.2856 12.5497 32.2856 14.2857C32.2856 16.0217 30.8789 17.4285 29.1428 17.4285C27.4068 17.4285 26 16.0217 26 14.2857Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.24cc15ce35bee68113da827ac050aba1.svg";
export { ForwardRef as ReactComponent };